<template>
  <div id="missionday" class="fixed-content">
    <video-display v-model="video.show"
                   :source="video.source">
    </video-display>
    <tabs v-model="tab" :transition="0">
      <tab :key="sc.tab.key" :title="sc.tab.title" v-if="sc.showFutureMissionDay">
        <page-section :header="require('@/assets/vinci.jpg')"
               :title="sc.main.title"
               :subtitle="sc.main.subtitle">
          <div class="row feature-block-row-with-hints">
            <div class="col-md-1" />
            <div v-for="b in sc.texts"
                 :key="`${b.key}-feature-block`">
              <div class="col-md-1" />
              <feature-block
                class="col-md-2 col-sm-4 col-xs-6"
                :title="b.title" :image="b.image"
                :subtitle="b.subtitle" :text="b.text" :icon="b.icon">
              </feature-block>
            </div>
          </div>
        </page-section>
        <page-section title="Programme"
                      type="dark-base">
          <div class="row program" v-if="sc.program.length > 0 && sc.showProgramAndDownloads">
            <div class="col-xs-10 col-xs-offset-1 col-lg-offset-2 col-lg-8">
              <div class="row program-text"
                   :class="`program-text-${p.type}`"
                   v-for="p in sc.program"
                   :key="`${p.key}-program-text`">
                <div class="col-xs-2 text-center program-time">
                  <h4>{{ p.time }}</h4>
                </div>
                <div class="col-xs-10 program-texts" v-if="!p.split">
                  <h5>
                    <span v-for="(t, i) in p.texts"
                          :key="`${p.key}-text-${i}`"
                          v-html="t">
                      <br />
                    </span>
                  </h5>
                  <span v-for="(st, i) in p.subtexts"
                        class="program-subtexts"
                        :key="`${p.key}-subtext-${i}`" v-html="st">
                    <br />
                  </span>
                </div>
                <div v-else class="col-xs-10 program-texts">
                  <div class="row">
                    <div class="col-xs-6"
                         v-for="(v, k) in p.values"
                         :key="`${p.key}-split-${k}`">
                      <div v-if="v.title" class="program-split-title">
                        {{v.title}}
                      </div>
                      <div v-for="(l, j) in v.list"
                           class="program-split-item"
                           :key="`${p.key}-split-${k}-${j}`">
                        <h5>
                          <span v-for="(t, z) in l.texts"
                                :key="`${p.key}-split-${k}-${j}-text-${z}`"
                                v-html="t">
                            <br />
                          </span>
                        </h5>
                        <span v-for="(st, z) in l.subtexts"
                              class="program-subtexts"
                              :key="`${p.key}-split-${k}-${j}-subtext-${z}`">
                          {{ st }}<br />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-4 col-xs-offset-4">
                <a href="#missionday-downloads"
                   v-smooth-scroll="{ duration: 500 }"
                   class="btn btn-lg btn-block action-btn btn-success">
                  Je m'inscris !
                </a>
              </div>
            </div>
          </div>
          <div v-else class="col-xs-12 col-md-6 col-md-offset-3">
            <alert type="warning" class="text-center">
              <strong>
                Programme à venir
              </strong>
            </alert>
          </div>
        </page-section>
        <page-section v-if="sc.showProgramAndDownloads"
                      title="Téléchargements"
                      id="missionday-downloads">
          <div class="row">
            <div class="col-md-offset-1" />
            <div class="col-xs-6 col-md-4 col-md-offset-1"
                 v-for="b in sc.files"
                 :key="`${b.key}-button`">
              <a :href="require(`@/assets/${b.link}`)"
              class="btn btn-lg btn-block action-btn"
              :class="`btn-${b.type}`"
              target="_blank"
              :disabled="b.disabled"
              :download="b.description">
                <span class="icon-container">
                  <svg-icon :icon="b.icon" color="white"/>
                </span>
                {{ b.title }}
                <div><small>{{ b.text }}</small></div>
              </a>
            </div>
          </div>
        </page-section>
      </tab>
      <tab v-for="c in sc.congresses"
           :key="c.key"
           :title="c.year">
        <page-section :title="`Journée nationale SPIADI ${c.year}`"
               :subtitle="c.title">
          <div class="row">
            <div class="col-xs-12">
              <carousel :indicators="false" :interval="3000" class="carousel">
                <slide v-for="slide in c.slides" :key="slide.key">
                  <div class="img-container">
                    <img :src="require(`@/assets/img/missionday/${slide.src}`)"
                class="img-responsive">
                  </div>
                  <div class="carousel-caption">
                    <h3>{{slide.title}}</h3>
                  </div>
                </slide>
              </carousel>
            </div>
          </div>
        </page-section>
        <page-section title="Interventions"
                      type="dark-base">
          <div class="row">
            <div class="col-xs-12 col-lg-8 col-lg-offset-2 text-center">
              <btn-group v-if="hasAltPictures[c.key]">
                <btn v-model="picturesType"
                     input-type="radio"
                     input-value="src">
                  Photos
                </btn>
                <btn v-model="picturesType"
                     input-type="radio"
                     input-value="alt">
                  Dessins
                </btn>
              </btn-group>
              <alert  v-if="hasUnavailableFilesAlert[c.key]"
                      type="warning"
                      class="text-justify">
                <p>
                  Toutes les présentations ne sont pas encore disponibles au téléchargement :
                  <ul>
                    <li>
                      les présentations de l'équipe SPIADI sont en cours d'enrichissement
                      avec les données nationales non présentées lors de la journée
                    </li>
                    <li>
                      les présentations de l'après-midi sont en attente des autorisations
                      des auteurs et autrices
                    </li>
                  </ul>
                  <strong>
                    Les documents seront mis à disposition sur cette page dès que possible.
                  </strong>
                </p>
              </alert>
              <speech v-for="p in c.speeches" :key="`${c.key}-${p.key}-speech`"
                      @click="triggerClickIFN(p.display)"
                      :hover="p.hover != null ? p.hover : 'Télécharger la présentation'"
                      :target="p.target"
                      :disabled="p.disabled"
                      :description="p.description"
                      :type="p.type"
                      :src="`missionday/${getPicture(p.src, p.alt)}`"
                      :texts="p.texts"
                      :subtexts="p.subtexts">
              </speech>
            </div>
          </div>
        </page-section>
        <page-section title="Communications orales">
          <div class="row">
            <div class="col-xs-12 col-lg-8 col-lg-offset-2">
              <speech v-for="p in c.communications" :key="`${c.key}-${p.key}-com`"
                      :hover="p.hover"
                      :target="p.target"
                      :disabled="p.disabled"
                      :description="p.description"
                      :type="p.type"
                      :src="p.src"
                      :texts="p.texts"
                      :subtexts="p.subtexts">
              </speech>
            </div>
          </div>
        </page-section>
      </tab>
    </tabs>
    <div id="missionday-logos">
      <div class="container" id="missionday-logos-container">
        <div class="row logo">
          <div class="col-xs-12">
            <img class="img-responsive"
                 :src="require('@/assets/img/logo-repias.png')" />
            <img class="img-responsive"
                 :src="require('@/assets/img/logo-spf.svg')" />
            <img class="img-responsive"
                 :src="require('@/assets/img/logo-tours-evenements.png')" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import pageSection from '@/components/pagesection'
import linkBlock from '@/components/linkBlock'
import featureBlock from '@/components/featureBlock'
import videoDisplay from '@/components/help/videodisplay'
import speech from '@/components/missionday/speech'
import svgIcon from '@/sui/components/svgIcon'

import sc from '@/views/sc/missionday'

export default {
  name: 'missionday',

  data () {
    const tab = parseInt(this.$route.query.tab)
    return {
      picturesType: 'src',
      video: {
        show: false,
        source: null
      },
      sc: sc,
      tab: (isNaN(tab)) ? 0 : tab
    }
  },

  watch: {
    '$route.query.tab': function (v) {
      const t = parseInt(v)
      this.tab = (isNaN(t)) ? 0 : t
    },

    'video.show': function (v) {
      if (!v) {
        this.video.source = null
      }
    }
  },

  methods: {
    getPicture: function (src, alt) {
      if (this.displayAltPictures && alt != null) {
        return alt
      }
      return src
    },

    triggerClickIFN: function (display) {
      if (display == null) {
        return
      }

      if (display.type === 'video') {
        const video = this.video
        video.source = display.source
        video.show = true
      }
    }
  },

  computed: {
    hasAltPictures: function () {
      function isAltInSpeeches (s) {
        for (let j = 0; j < s.length; j++) {
          const sp = s[j]
          if (sp.alt != null) {
            return true
          }
        }
        return false
      }

      const congresses = this.sc.congresses
      const result = {}
      for (let i = 0; i < congresses.length; i++) {
        const congress = congresses[i]
        const congressKey = congress.key
        const speeches = congress.speeches
        result[congressKey] = isAltInSpeeches(speeches)
      }
      return result
    },

    hasUnavailableFilesAlert: function () {
      const congresses = this.sc.congresses
      const result = {}

      for (let i = 0; i < congresses.length; i++) {
        const congress = congresses[i]
        const hasAlert = congress.unavailableFilesAlert
        result[congress.key] = hasAlert || false
      }
      return result
    },

    displayAltPictures: function () {
      return this.picturesType === 'alt'
    }
  },

  components: {
    'video-display': videoDisplay,
    'feature-block': featureBlock,
    'link-block': linkBlock,
    pageSection,
    'speech': speech,
    'svg-icon': svgIcon
  }
}
</script>

<style scoped lang="less">
@import '~variables';
@import '~mixins';

.feature-block-row {
  @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max){
    .col-sm-4:nth-child(4n+1) {
      clear: both;
    }
  }
}

.carousel {
  max-height: 60rem;
  border-radius: 15px;
  overflow: hidden;
  margin-bottom: 3rem;

  .img-container {
    max-height: 60rem;
  }
}

.ligue {
  a {
    color: white;
    .underlined-link();
  }

  a:hover {
    color: @brand-warning;
  }

  a:focus {
    outline: 0rem;
  }
}

#missionday-logos {
  border-top: 5rem solid @dark-base;
  border-bottom: 5rem solid @dark-base;
}

#missionday-logos-container {
  padding-top: 4rem;
  padding-bottom: 4rem;
  .logo {
    text-align: center;
  }

  .logo img {
    display: inline-block;
    max-height: 6rem;
    margin-left: 1rem;
    margin-right: 1rem;
    @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {
      max-height: 5rem;
    }
    @media (min-width: 0) and (max-width: @screen-xs-max) {
      max-height: 3rem;
    }
  }
}

.speech-text {
  position: relative;
  padding: 1rem;
  margin: 2rem 0rem;
  text-align: justify;
  border-radius: 1rem;

  img {
    border-radius: 1rem;
  }

  h4 {
    color: black;
  }
  color: @dark-base;
}

.speech-dl {
  opacity: 0;
  bottom: 10%;
  width: 100%;
  left: 0%;
  position: absolute;
  zOrder: 10;
  background-color: @dark-base;
  color: white;
  transition: .5s ease;
  text-align: center;
  span {
    font-size: 140%;
  }
}

.speech-texts {
  transition: .5s ease;
}

.speech-img {
  transition: .5s ease;
}

.speech-link:hover {

  .speech-texts {
    opacity: 0.2;
  }

  .speech-img {
    opacity: 0.2;
  }

  .speech-dl {
    opacity: 0.8;
  }
}
.feature-block-row {
  @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max){
    .col-sm-4:nth-child(4n+1) {
      clear: both;
    }
  }
}

.ligue {
  a {
    color: white;
    .underlined-link();
  }

  a:hover {
    color: @brand-warning;
  }

  a:focus {
    outline: 0rem;
  }
}

#missionday-logos {
  border-top: 5rem solid @dark-base;
  border-bottom: 5rem solid @dark-base;
}

#missionday-logos-container {
  padding-top: 4rem;
  padding-bottom: 4rem;
  .logo {
    text-align: center;
  }

  .logo img {
    display: inline-block;
    max-height: 6rem;
    margin-left: 1rem;
    margin-right: 1rem;
    @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {
      max-height: 5rem;
    }
    @media (min-width: 0) and (max-width: @screen-xs-max) {
      max-height: 3rem;
    }
  }
}
.program {
  .program-text {
    h5 {
      font-weight: bold;
      font-size: 105%;
    }
  }

  .program-text:last-child {
    border-bottom-left-radius: 1rem;
    border-bottom-right-radius: 1rem;
  }

  .program-text:first-child {
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }

  .program-text-std {
    background-color: white;
    color: @base-text;
    .program-texts {
      border-color: @base;
    }
  }

  .program-text-alt {
    background-color: #eee;
    color: @base-text;
    .program-texts {
      border-color: @base;
    }
  }

  .program-text-pause {
    background-color: @brand-warning;
    .program-subtexts,
    .program-time h4,
    .program-texts h5 {
      color: white;
    }
    .program-texts:before {
      background-color: white;
    }
  }

  .program-subtexts {
    font-size: 90%;
    color: @dark-base;
    text-align: justify;
  }

  .program-text-highlight {
    background-color: @base;
    .program-subtexts, .program-time h4, .program-texts h5 {
      color: white;
    }

    .program-texts:before {
      background-color: white;
    }
  }

  .program-time {
    padding-top: 1.5rem;
    h4 {
      margin-bottom: 0.2rem;
      margin-top: 0.2rem;
      color: @dark-base;
    }
  }

  .program-texts {
    border-left: 1px solid white;
    padding-bottom: 1.5rem;
    padding-top: 1.5rem;
    h5 {
      margin-bottom: 0.2rem;
      margin-top: 0.2rem;
      color: @dark-base;
    }
  }

  .program-texts:before {
    content: '';
    position: absolute;
    top: 0%;
    left: 0%;
    margin-left: -0.6rem;
    margin-top: 2.2rem;
    width: 1.1rem;
    height: 1.1rem;
    border-radius: 50%;
    background-color: @base;
  }

  .program-split-title {
    background: @base;
    color: white;
    width: 100%;
    text-align: center;
    padding: 0.2rem 0.2rem;
    border-radius: 0.2rem;
    font-weight: bold;
  }
}

.action-btn {
  margin-top: 4rem;
  margin-bottom: 4rem;
  font-size: 160%;
  small {
    font-size: 50%;
  }
  .icon-container {
    .svg-icon {
      width: 15%
    }
  }
}

.action-btn:last-child {
  margin-bottom: 0rem;
}

</style>
